import React from "react";
import Table2 from "../Table2/Table2";
import select from "../../images/icons/pointer.png";
import External_In_Map from "../External_Visites/External_In_Map";
import FilterStatistics from "../Main/Statistics/FilterStatistics";
import { useSelectorCustom } from "../General/GeneralComponent/useSelectorCustom";
import {
    ColumnArrayReportHospital,
  VariableReports,
} from "./VariableReports";

function Hospital({ langmiamed, t, navigate, setopenInternet }) {
  const { hospital, loaginghospital } = useSelectorCustom();
  const reversedgeneralExReport = hospital?.reverse();
  const { state, storeMap, setIsOpen } = VariableReports();
  const { HospitalReqsColumn } = ColumnArrayReportHospital(t, storeMap);
  return (
    <>
      <FilterStatistics
        t={t}
        langmiamed={langmiamed}
        params="hospital"
        excel="hospital"
      />
      <div className="users" dir={langmiamed == "ar" ? "ltr" : "ltr"}>
        {loaginghospital == false ? (
          <Table2 col={HospitalReqsColumn} roo={reversedgeneralExReport} />
        ) : (
          <div className="alternative">
            <img src={select} />
            <br></br>
            <p>{t("filterr")}</p>
          </div>
        )}
      </div>
      {state.openMap && (
        <External_In_Map
          open={state.openMap}
          setOpen={setIsOpen}
          lat={state.lat}
          lng={state.lng}
        />
      )}
    </>
  );
}

export default Hospital;
